export interface Filters {
  country: string;
  city: string;
  activeFilters: Filter[];
  page: number;
  lang: string;
}

export interface SearchFilters {
  activeFilters: Filter[];
  country: string;
  city: string;
}

export interface SubOption {
  id: number;
  name: string;
  value: string;
  queryValue?: string;
  short?: string;
}

export interface Filter {
  id: number;
  uid: string;
  name: string;
  subOptions: SubOption[];
  collapsible?: boolean;
  order?: number;
  queryName: string;
  searchWithOthersQueryName?: string;
  value?: any;
  hideIfEmpty?: boolean;
  defaultValue?: any;
}

export enum SearchMode {
  EXPERIENCES = 'Experiences',
  LOCALS = 'Locals',
  ALL = 'All',
  LANDING_PAGE = 'Landing Page',
}
